export enum ACTIONS {
  ADD_VERIFIED_TRANS = "ADD_VERIFIED_TRANS",
  UPDATE_VERIFIED_TRANS = "UPDATE_VERIFIED_TRANS",
  UPDATE_SELECTED_TRANS = "UPDATE_SELECTED_TRANS",
  UPDATE_USERS = "UPDATE_USERS",
  SET_MAIN_USER = "SET_MAIN_USER",
  ADD_BLOCK = "ADD_BLOCK",
  UPDATE_BLOCK = "UPDATE_BLOCK",
  UPDATE_PREVIEW = "UPDATE_PREVIEW",
  ASSIGN_COPIED = "ASSIGN_COPIED",
  SET_SIGNED = "SET_SIGNED",
  SET_VALIDATED = "SET_VALIDATED",
  SET_DETAILS = "SET_DETAILS"
}
